import "./Loading.css"

const Loading = () => {
    return (
        <div id="waitProc" className="ring" >Processando
            <span id="waitSpan"></span>
        </div>
    )
}
export default Loading